import { useState } from 'react';
import { FaWhatsapp, FaFacebookF, FaTwitter, FaTelegramPlane } from 'react-icons/fa';
import { FiLink, FiShare2, FiCheck } from 'react-icons/fi';

// Share the current page across channels (+ native share + copy link).
export default function ShareButtons({ title = '', url }) {
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const [copied, setCopied] = useState(false);
  const text = encodeURIComponent(`Check this out: ${title}`);
  const u = encodeURIComponent(shareUrl);

  const links = [
    { icon: <FaWhatsapp />, href: `https://wa.me/?text=${text}%20${u}`, color: '#25d366' },
    { icon: <FaFacebookF />, href: `https://www.facebook.com/sharer/sharer.php?u=${u}`, color: '#1877f2' },
    { icon: <FaTwitter />, href: `https://twitter.com/intent/tweet?text=${text}&url=${u}`, color: '#1da1f2' },
    { icon: <FaTelegramPlane />, href: `https://t.me/share/url?url=${u}&text=${text}`, color: '#29a9eb' },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {}
  };

  const nativeShare = () => {
    if (navigator.share) navigator.share({ title, url: shareUrl }).catch(() => {});
  };

  return (
    <div className="share-row">
      {links.map((l, i) => (
        <a key={i} href={l.href} target="_blank" rel="noreferrer" className="share-btn" style={{ color: l.color }}>
          {l.icon}
        </a>
      ))}
      <button className="share-btn" onClick={copy} title="Copy link">
        {copied ? <FiCheck color="var(--success)" /> : <FiLink />}
      </button>
      {typeof navigator !== 'undefined' && navigator.share && (
        <button className="share-btn" onClick={nativeShare} title="Share"><FiShare2 /></button>
      )}
    </div>
  );
}
